<!--
 * @Description: 
 * @Version: 2.0
 * @Autor: whaoo
 * @Date: 2023-12-27 14:34:09
 * @LastEditors: whaoo
 * @LastEditTime: 2024-01-10 15:14:52
-->
<template>
    <div class="login">
        <img v-if="is_small" src="../../assets/login/bg_1.png" class="login_bg" alt="">
        <img v-else src="../../assets/login/bg.png" class="login_bg" alt="">
        <img src="../../assets/login/waiter.png" class="waiter" alt="">
        <img src="../../assets/login/logo.png" class="logo" alt="">

        <div class="title">同济医院智慧病房护理服务平台

            <img src="../../assets/login/tips.png" class="tips_logo" alt="">
        </div>
        <div class="login_box">
            <div class="input_box">
                <div class="input flex_box">
                    <img src="../../assets/login/user.png" class="left_icon">
                    <img src="../../assets/login/input_icon.png" class="center_icon">
                    <input type="text" v-model="zone_number" placeholder="账号">
                    <div class="tips" v-show="showUserTips">请输入账号</div>
                </div>
                <div class="input flex_box mb3">
                    <img src="../../assets/login/password.png" class="left_icon">
                    <img src="../../assets/login/input_icon.png" class="center_icon">
                    <input @keyup.enter="login" type="password" v-model="password" placeholder="密码">
                    <div class="tips" v-show="showPasswordTips">请输入密码</div>
                </div>

                <div class="comfirm_btn" @click="login">
                    登录
                </div>
                <div class="forget" @click="forget">忘记账号密码？</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            is_small: false,
            zone_number: "",
            password: "",
            showUserTips: false,
            showPasswordTips: false,
        };
    },


    mounted() {
        if (this.$cookies.get('token')) {
            this.$router.push('/device_list')
        }
        if (document.body.clientWidth / document.body.clientHeight < 1.6) {
            this.is_small = true
        }
    },

    methods: {
        login() {
            if (!this.zone_number && !this.password) {
                this.showUserTips = true
                this.showPasswordTips = true
            }
            if (!this.zone_number) {
                this.showUserTips = true
                return
            } else {
                this.showUserTips = false
            }
            if (!this.password) {
                this.showPasswordTips = true
                return
            } else {
                this.showPasswordTips = false
            }

            let data = {
                zone_number: this.zone_number,
                password: this.password
            }
            this.$http({
                url: '/api/zone/login',
                method: "post",
                data: data
            }).then(res=>{
                console.log(res);
                this.$message.success("登录成功！")
                this.$cookies.set('token',res.result.token,'7d')
                this.$cookies.set('zone_number',res.result.zone_number,'7d')
                setTimeout(() => {
                    this.$router.push('/device_list')
                }, 2000);
            })
        },
        forget() {
            this.$alert('<div style="text-align:center;">若您忘记账号密码，可拨打以下电话找回<br/>技术运维电话：400-9616-639</div>', '忘记账号密码', {
                confirmButtonText: '确定',
                dangerouslyUseHTMLString: true
            });
        }
    }
}

</script>
<style  scoped>
.login {
    width: 100%;
    height: 100vh;
    position: relative;
    font-size: 0;
    overflow: hidden;
}

.login_bg {
    width: 100%;
    height: 100%;
    object-fit: cover;
    position: absolute;
    left: 0;
    top: 0;
}

.waiter {
    width: 28%;
    height: auto;
    position: absolute;
    left: 5%;
    bottom: -3%;
    z-index: 999;
}

.logo {
    width: auto;
    height: 50px;
    position: absolute;
    left: 2%;
    top: 4%;
}

.title {
    font-size: 54px;
    font-weight: bold;
    color: #FFFFFF;
    margin: 200px auto 50px;
    letter-spacing: 4px;
    position: relative;
    z-index: 99;
    text-align: center;
    position: relative;
}

.login_box {
    position: relative;
    width: 40%;
    height: 42%;
    margin: 0 auto;
    /* background-color: rgba(170, 170, 170, 0.712); */
    overflow: hidden;
    border-radius: 10px;

}

.input_box {
    position: absolute;
    width: 50%;
    height: 100%;
    left: 25%;
    top: 0;
    z-index: 999;
    padding-top: 50px;
}

.login_box::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(143, 143, 143, 0.329);
    backdrop-filter: blur(10px);
}

.login_overlay {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
}

.flex_box {
    display: flex;
}

.input {
    padding: 17px 26px;
    border-radius: 100px;
    background-color: rgba(173, 173, 173, 0.527);
    width: 100%;
    margin-bottom: 20px;
    position: relative;
}

.left_icon {
    width: auto;
    height: 20px;
    margin-right: 20px;
}

.center_icon {
    width: 1px;
    height: 15px;
    margin-right: 20px;
    position: relative;
    top: 2px;
}

input {
    background-color: #FFFFFF00 !important;
    border: none;
    height: 20px;
    line-height: 20px;
    width: calc(100% - 42px);
}

input::placeholder {
    color: #DCEAF9;
}

input:focus {
    outline: none;
}

input:-webkit-autofill , textarea:-webkit-autofill, select:-webkit-autofill {  
    /* -webkit-text-fill-color: #ededed !important;   */
    -webkit-box-shadow: 0 0 0px 1000px transparent  inset !important;  
    background-color:transparent;  
    background-image: none;  
    transition: background-color 50000s ease-in-out 0s;  
}

.mb3 {
    margin-bottom: 30px;
}

.comfirm_btn {
    width: 100%;
    height: 50px;
    border-radius: 50px;
    background-color: #6377F5;
    color: #FFFFFF;
    text-align: center;
    line-height: 50px;
    font-size: 20px;
    letter-spacing: 5px;
    margin-bottom: 10px;
    cursor: pointer;
}

.tips {
    position: absolute;
    bottom: -20px;
    font-size: 14px;
    color: red;
}

.forget {
    font-size: 16px;
    color: #FFFFFF;
    cursor: pointer;
    text-align: center;
}
.tips_logo {
    width: 140px;
    opacity: .7;
    position: absolute;
    /* right: 0px; */
}
</style>


// WEBPACK FOOTER //
// src/view/layout/login.vue